module.exports = __webpack_public_path__ + "static/media/imcivree-logo.6219ddda.svg";